/** Selects the sorted dual-name specialties list from the app query. */
export const useTemplateSpecialties = <TSpecialties>(
  querySpecialties: (select: (data: { specialties: TSpecialties }) => TSpecialties) => {
    data: TSpecialties | undefined;
  }
) => querySpecialties((data) => data.specialties);
